import { useMemo, useState } from 'react';
import styled from 'styled-components';
import { isuGroupApi } from '../../../core/api/rtk-query/isu-group.api';
import { IsuGroupDetailsModal } from './IsuGroupDetailsModal';

const Wrap = styled.div`display:grid; gap:12px;`;
const Toolbar = styled.div`display:flex; gap:8px; align-items:center;`;
const Input = styled.input`padding:10px 12px; border-radius:10px; border:1px solid #dbe3f6; background:#fff; color:#0b1221;`;
const Btn = styled.button`background:#fff; border:1px solid #dbe3f6; color:#0b1221; padding:8px 12px; border-radius:10px; cursor:pointer;`;
const Grid = styled.div`
  display:grid; gap:12px; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
`;
const Card = styled.div`
  background:#fff; border:1px solid #e5e8f0; border-radius:12px; padding:12px; box-shadow:0 8px 24px rgba(0,0,0,.06);
  display:flex; flex-direction:column; gap:8px;
`;
const Title = styled.div`font-weight:600; color:#0b1221;`;
const Count = styled.div`color:#465676; font-size:12px;`;

export const AdminIsuGroupsPage = () => {
  const { data, refetch } = isuGroupApi.useGetIsuGroupsQuery();
  const [rename] = isuGroupApi.useRenameIsuGroupMutation();
  const [filter, setFilter] = useState('');
  const [newName, setNewName] = useState('');

  const list = useMemo(() => (data||[])
    .filter(g => g.name?.toLowerCase().includes(filter.toLowerCase()))
    .sort((a,b)=> a.name.localeCompare(b.name)), [data, filter]);

  const onCreate = async () => {
    const name = newName.trim(); if(!name) return;
    await rename({ from: name, to: name }).unwrap(); // no-op if нет ни одного пользователя
    setNewName(''); await refetch();
  };

  const [detailsName, setDetailsName] = useState<string | null>(null);

  return (
    <Wrap>
      <Toolbar>
        <h2 style={{margin:0}}>Группы ИСУ</h2>
        <div style={{marginLeft:'auto', display:'flex', gap:8}}>
          <Input placeholder="Фильтр…" value={filter} onChange={e=> setFilter(e.target.value)} />
          <Input placeholder="Новая группа…" value={newName} onChange={e=> setNewName(e.target.value)} />
          <Btn onClick={onCreate}>Добавить</Btn>
        </div>
      </Toolbar>

      <Grid>
        {list.map(g => (
          <Card key={g.name}>
            <Title>{g.name || '—'}</Title>
            <Count>{g.count} участников</Count>
            <div style={{ display:'flex', gap:8, marginTop:4 }}>
              <Btn onClick={()=> setDetailsName(g.name)}>Детали</Btn>
            </div>
          </Card>
        ))}
      </Grid>

      {detailsName && (
        <IsuGroupDetailsModal
          name={detailsName}
          onClose={()=> setDetailsName(null)}
          onChanged={async()=> { await refetch(); }}
        />
      )}
    </Wrap>
  );
};


